export default function format(date, fallback) {
  if (!(date instanceof Date)) date = new Date(+date);
  if (isNaN(date)) return typeof fallback === "function" ? fallback(date) : fallback;
  var hours = date.getUTCHours();
  var minutes = date.getUTCMinutes();
  var seconds = date.getUTCSeconds();
  var milliseconds = date.getUTCMilliseconds();
  return "".concat(formatYear(date.getUTCFullYear(), 4), "-").concat(pad(date.getUTCMonth() + 1, 2), "-").concat(pad(date.getUTCDate(), 2)).concat(hours || minutes || seconds || milliseconds ? "T".concat(pad(hours, 2), ":").concat(pad(minutes, 2)).concat(seconds || milliseconds ? ":".concat(pad(seconds, 2)).concat(milliseconds ? ".".concat(pad(milliseconds, 3)) : "") : "", "Z") : "");
}

function formatYear(year) {
  return year < 0 ? "-".concat(pad(-year, 6)) : year > 9999 ? "+".concat(pad(year, 6)) : pad(year, 4);
}

function pad(value, width) {
  return "".concat(value).padStart(width, "0");
}